import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import ContextMenu from '@/components/context-menu'
import Icon from '@/components/icon'
import { colors } from '@/styles'
import ItemContainer from './placeholder-items'

export const VideoPlayButton = styled.div`
  position: absolute;
  background: transparent;
  border: none;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  ${props =>
    props.disabled &&
    `
    opacity: 0.3;
    cursor: default;
  `}
`

const VideoPreview = ({ onRemove, onPlay, children, disabled, ...rest }) => {
  const [t] = useTranslation()
  const contextMenuItems = [
    {
      onClick: onRemove,
      label: t('common.remove', 'Remove'),
      color: colors.red
    }
  ]

  return (
    <ItemContainer {...rest}>
      {children}
      <VideoPlayButton onClick={disabled ? null : onPlay} disabled={disabled}>
        <Icon id="play" width={90} height={90} />
      </VideoPlayButton>
      <ContextMenu items={contextMenuItems} />
    </ItemContainer>
  )
}

export default VideoPreview
